/* tslint:disable */

/* eslint-disable */

/**
 * Title
 * Title
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';

/**
 *
 * @export
 * @interface Message
 */
export interface Message {
    [key: string]: object | any;
    /**
     *
     * @type {string}
     * @memberof Message
     */
    message?: string;
}

export function MessageFromJSON(json: any): Message {
    return MessageFromJSONTyped(json, false);
}

export function MessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Message {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        ...json,
        message: !exists(json, 'message') ? undefined : json['message'],
    };
}

export function MessageToJSON(value?: Message | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...value,
        message: value.message,
    };
}
